import { DashboardStats, EarningsData, Booking, Message, Review, PropertyStats } from '../types/Dashboard';

export const getDashboardStats = (): DashboardStats => ({
  totalEarnings: 34500,
  monthlyAverage: 5750,
  activeBookings: 24,
  totalReviews: 142,
  averageRating: 4.8,
  monthlyGrowth: 12.5,
  occupancyRate: 85,
  totalGuests: 156
});

export const getEarningsData = (): EarningsData[] => [
  { month: 'Jan', earnings: 4200, bookings: 12, growth: 8.5 },
  { month: 'Feb', earnings: 3800, bookings: 10, growth: -9.5 },
  { month: 'Mar', earnings: 5100, bookings: 15, growth: 34.2 },
  { month: 'Apr', earnings: 4700, bookings: 13, growth: -7.8 },
  { month: 'May', earnings: 6200, bookings: 18, growth: 31.9 },
  { month: 'Jun', earnings: 5800, bookings: 16, growth: -6.5 }
];

export const getUpcomingBookings = (): Booking[] => [
  {
    id: '1',
    guestName: 'Sarah Johnson',
    propertyName: 'Luxury Villa',
    location: 'Miami Beach, FL',
    checkIn: new Date(2024, 3, 15),
    checkOut: new Date(2024, 3, 20),
    status: 'upcoming',
    guestImage: 'https://picsum.photos/200/200?random=1',
    totalAmount: 1250,
    numberOfGuests: 2
  },
  {
    id: '2',
    guestName: 'Michael Chen',
    propertyName: 'Beachfront Suite',
    location: 'Malibu, CA',
    checkIn: new Date(2024, 3, 18),
    checkOut: new Date(2024, 3, 22),
    status: 'upcoming',
    guestImage: 'https://picsum.photos/200/200?random=2',
    totalAmount: 1800,
    numberOfGuests: 3
  },
  {
    id: '3',
    guestName: 'Emma Davis',
    propertyName: 'Mountain Cabin',
    location: 'Aspen, CO',
    checkIn: new Date(2024, 3, 12),
    checkOut: new Date(2024, 3, 16),
    status: 'in-progress',
    guestImage: 'https://picsum.photos/200/200?random=3',
    totalAmount: 2200,
    numberOfGuests: 4
  }
];

export const getRecentMessages = (): Message[] => [
  {
    id: '1',
    sender: {
      id: 'user1',
      name: 'David Wilson',
      image: 'https://picsum.photos/200/200?random=4',
      status: 'online'
    },
    content: 'Hi, I was wondering about the check-in process for tomorrow. Could you please provide more details?',
    preview: 'Hi, I was wondering about the check-in process for tomorrow. Could you please provide more details?',
    timestamp: new Date(2024, 3, 12, 14, 30),
    unread: true
  },
  {
    id: '2',
    sender: {
      id: 'user2',
      name: 'Lisa Anderson',
      image: 'https://picsum.photos/200/200?random=5',
      status: 'offline'
    },
    content: 'Thank you for the amazing stay! We loved the property and will definitely be coming back soon.',
    preview: 'Thank you for the amazing stay! We loved the property and will definitely be coming back soon.',
    timestamp: new Date(2024, 3, 12, 10, 15),
    unread: false
  },
  {
    id: '3',
    sender: {
      id: 'user3',
      name: 'James Taylor',
      image: 'https://picsum.photos/200/200?random=6',
      status: 'away'
    },
    content: 'Is early check-in possible on Friday? We\'ll be arriving around 11 AM.',
    preview: 'Is early check-in possible on Friday? We\'ll be arriving around 11 AM.',
    timestamp: new Date(2024, 3, 11, 18, 45),
    unread: true
  }
];

export const getLatestReviews = (): Review[] => [
  {
    id: '1',
    guest: {
      id: 'guest1',
      name: 'Sophie Martin',
      image: 'https://picsum.photos/200/200?random=7',
      bookingsCount: 5,
      memberSince: new Date(2023, 1, 15)
    },
    rating: 5,
    cleanliness: 5,
    communication: 5,
    checkIn: 5,
    accuracy: 5,
    location: 5,
    value: 5,
    comment: 'Absolutely wonderful stay! The property exceeded our expectations in every way.',
    property: {
      id: 'prop1',
      name: 'Luxury Villa',
      image: 'https://picsum.photos/200/200?random=10',
      location: 'Miami Beach, FL'
    },
    date: new Date(2024, 3, 10),
    helpful: 0,
    status: 'published'
  },
  {
    id: '2',
    guest: {
      id: 'guest2',
      name: 'Robert Chen',
      image: 'https://picsum.photos/200/200?random=8',
      bookingsCount: 3,
      memberSince: new Date(2023, 6, 20)
    },
    rating: 4,
    cleanliness: 4,
    communication: 4,
    checkIn: 4,
    accuracy: 4,
    location: 4,
    value: 4,
    comment: 'Great location and beautiful property. Very clean and well-maintained.',
    property: {
      id: 'prop2',
      name: 'Beachfront Suite',
      image: 'https://picsum.photos/200/200?random=11',
      location: 'Malibu, CA'
    },
    date: new Date(2024, 3, 8),
    helpful: 0,
    status: 'published'
  },
  {
    id: '3',
    guest: {
      id: 'guest3',
      name: 'Emily Wilson',
      image: 'https://picsum.photos/200/200?random=9',
      bookingsCount: 7,
      memberSince: new Date(2022, 11, 5)
    },
    rating: 5,
    cleanliness: 5,
    communication: 5,
    checkIn: 5,
    accuracy: 5,
    location: 5,
    value: 5,
    comment: 'Perfect getaway spot! The attention to detail was amazing.',
    property: {
      id: 'prop3',
      name: 'Mountain Cabin',
      image: 'https://picsum.photos/200/200?random=12',
      location: 'Aspen, CO'
    },
    date: new Date(2024, 3, 5),
    helpful: 0,
    status: 'published'
  }
];

export const getPropertyStats = (): PropertyStats[] => [
  {
    id: '1',
    name: 'Luxury Villa',
    occupancyRate: 85,
    averageRating: 4.8,
    totalBookings: 48,
    totalEarnings: 12500,
    recentReviews: 12,
    pendingBookings: 3,
    monthlyGrowth: 15.5,
    maintenanceStatus: 'good'
  },
  {
    id: '2',
    name: 'Beachfront Suite',
    occupancyRate: 92,
    averageRating: 4.6,
    totalBookings: 56,
    totalEarnings: 15800,
    recentReviews: 15,
    pendingBookings: 5,
    monthlyGrowth: 18.2,
    maintenanceStatus: 'good'
  },
  {
    id: '3',
    name: 'Mountain Cabin',
    occupancyRate: 78,
    averageRating: 4.9,
    totalBookings: 32,
    totalEarnings: 8900,
    recentReviews: 8,
    pendingBookings: 2,
    monthlyGrowth: 12.8,
    maintenanceStatus: 'needsAttention'
  }
];